const ufeApi = require('services/api/ufeApi');
const forBV = 'forBV';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+User-Specific+Product+Details+API

function getUserSpecificProductDetails(productId, skuId = null, checkVerified = false) {
    let url = `/api/users/profiles/current/product/${productId}?`;
    const queryParams = [];
    queryParams.push('skipAddToRecentlyViewed=false');

    if (skuId !== null) {
        if (skuId !== forBV) {
            queryParams.push(`preferedSku=${skuId}`);
        }

        if (checkVerified) {
            queryParams.push('verifiedPurchase=true');
        }
    }

    url = url + queryParams.join('&');

    return ufeApi
        .makeRequest(url, { method: 'GET' })
        .then(data => (data.errorCode ? Promise.reject(data) : data))
        .catch(reason => {
            // eslint-disable-next-line no-console
            console.error('getUserSpecificProductDetails failed for ' + `productId, skuId: ${productId}, ${skuId}.`);

            return Promise.reject(reason);
        });
}

module.exports = getUserSpecificProductDetails;
